import { Lock, LockOpen } from "lucide-react";

export default function CarrierTag({ carrier, className = "" }) {
  if (!carrier) return null;
  const unlocked = carrier.toLowerCase().includes("unlock");
  return (
    <span
      data-testid="carrier-tag"
      className={`inline-flex w-fit items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold ${unlocked ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"} ${className}`}
    >
      {unlocked ? <LockOpen className="h-3 w-3" /> : <Lock className="h-3 w-3" />}
      {carrier}
    </span>
  );
}
